import React, {Component} from 'react'
import {Field, FieldsManager} from '../../../data/services/fields'
import LocalStorage from '../../../util/localStorage'
import Resources from '../../../data/services/resources'
import {
    checkPerm,
    getDefaultTableOptions,
    getDefaultTableOptionsJSON,
    getLookup,
    getProp,
    longTableColumn,
    openInNewTab,
    saveTableColumns,
    verifyTableOptions
} from '../../../common/util/util-helpers'
import {genericMoneyFormatter} from "../../../common/util/util-vanilla";
import PageHeader from "../../../common/components/layout/layout-components/page/page-header";
import Pagination from "../../../common/components/resource-table/table-components/pagination";
import {READ_PERM, UPDATE_PERM} from "../../../util/util-constants";
import {getSecondResource} from "../../../data/actions/secondResource";
import NoRecords from "../../../common/components/no-records-found/no-records";
import ResourceTable from "../../../common/components/resource-table";
import Card from "../../../common/components/card";
import TableCard from "../../../common/components/resource-table/table-components/table-card";
import TableFilters from "../../../common/components/resource-table/table-components/table-filters";
import TableSettingsPopOver
    from "../../../common/components/resource-table/table-components/table-settings-popover";
import TableOptionsDialog from "../../../common/components/resource-table/table-components/table-options-dialog";
import {getThirdResource} from "../../../data/actions/thirdResource";
import ResourceListTab from "../../../common/components/tabs/resource-list-tab";
import Env from "../../../util/env";
import {EyeIcon} from "@heroicons/react/24/outline";
import WorkOrderStatusBadge from "../../../common/components/badge/work-order-status-badge/index";
import ResourceTableTags from "../../../common/components/resource-table/table-components/resource-table-tags";
import CellButton from "../../../common/components/resource-table/table-components/cell-button";
import Tooltip from "../../../common/components/tooltip";
import Button from "../../../common/components/button";
import ModalMvrRecordExport from "../../../common/components/modal/modal-mvr-record-export";
import {fillFieldsFromData} from "../../../common/util/util-fields";
import {showGlobalModal} from "../../../data/actions/ui";
import {DEFAULT_QUERY_LIMIT} from "../../../common/util/util-consts";

const WORK_ORDER_COMPLETED_STATUS_ID = 14;

const WO_TABLE_DEFAULTS = {
    behaviour: {
        rowSelect: false,
        hasMenu: true,
        canAdjustWidth: true
    }
};

export default class ServicesTab extends Component {

    constructor(props) {
        super(props)

        this.pagePathCurrentWO = this.props.tabKey + "_current_wo";
        this.pagePathPastWO = this.props.tabKey + "_past_wo";

        this.state = {
            sortCurrentWO: "ASC",
            sortByCurrentWO: "",
            offsetCurrentWO: 0,
            queryFilterFieldsCurrentWO: this.getQueryFilterFieldsCurrentWO(),
            tableOptionsCurrentWO: this.getTableOptions(this.pagePathCurrentWO),

            sortPastWO: "ASC",
            sortByPastWO: "",
            offsetPastWO: 0,
            queryFilterFieldsPastWO: this.getQueryFilterFieldsPastWO(),
            tableOptionsPastWO: this.getTableOptions(this.pagePathPastWO),

            columnsDialogTableKey: null,
            isMvrExportDialogOpen: false
        }
    }

    /** Lifecycle
     ================================================================= */
    componentDidMount = () => {
        this.fetchDataCurrentWO();
        this.fetchDataPastWO();
    }

    /** Data Events
     ================================================================= */
    fetchDataCurrentWO = () => {
        this.props.dispatch(getSecondResource({
            user: LocalStorage.get('user'),
            resource: Resources.WorkOrders,
            query: this.getQueryCurrentWO()
        }))
    }

    fetchDataPastWO = () => {
        this.props.dispatch(getThirdResource({
            user: LocalStorage.get('user'),
            resource: Resources.WorkOrders,
            query: this.getQueryPastWO()
        }))
    }

    /** UI Events
     ================================================================= */
    handleUpdateSortCurrentWO = (sortBy) => {
        this.setState({
            sortByCurrentWO: sortBy,
            sortCurrentWO: (this.state.sortByCurrentWO === sortBy) ? (this.state.sortCurrentWO === 'ASC' ? 'DESC' : 'ASC') : 'ASC'
        }, () => {
            this.fetchDataCurrentWO()
        })
    }

    handleUpdateSortPastWO = (sortBy) => {
        this.setState({
            sortByPastWO: sortBy,
            sortPastWO: (this.state.sortByPastWO === sortBy) ? (this.state.sortPastWO === 'ASC' ? 'DESC' : 'ASC') : 'ASC'
        }, () => {
            this.fetchDataPastWO()
        })
    }

    handleFilterInputChangeCurrentWO = (name, value) => {
        this.setState({
            queryFilterFieldsCurrentWO: FieldsManager.updateField(this.state.queryFilterFieldsCurrentWO, name, value),
            offsetCurrentWO: 0
        }, () => {
            this.fetchDataCurrentWO()
        })
    }

    handleFilterInputChangePastWO = (name, value) => {
        this.setState({
            queryFilterFieldsPastWO: FieldsManager.updateField(this.state.queryFilterFieldsPastWO, name, value),
            offsetPastWO: 0
        }, () => {
            this.fetchDataPastWO()
        })
    }

    handleUpdateOffsetCurrentWO = (offset) => {
        this.setState({
            offsetCurrentWO: offset
        }, () => {
            this.fetchDataCurrentWO()
        })
    }

    handleUpdateOffsetPastWO = (offset) => {
        this.setState({
            offsetPastWO: offset
        }, () => {
            this.fetchDataPastWO()
        })
    }

    handleViewTruckClick = (truckID) => {
        this.props.dispatch(showGlobalModal('ViewTruckCard', truckID));
    }

    handleViewTrailerClick = (trailerID) => {
        this.props.dispatch(showGlobalModal('ViewTrailerCard', trailerID));
    }

    handleOpenWorkOrder = (item) => {
        openInNewTab(Env.getTruckWorkOrdersUrl(`/work-orders/${item.WorkOrderID}`))
    }

    handleToggleMvrExportDialog = () => {
        this.setState({isMvrExportDialogOpen: !this.state.isMvrExportDialogOpen})
    }

    /** UI Events table
     ================================================================= */
    handleToggleColumnSettingsDialog = (tableKey = null) => {
        this.setState({columnsDialogTableKey: tableKey})
    }

    handleSetTableOptions = (tableKey, options) => {
        this.setState({[tableKey]: options}, () => {
            saveTableColumns(this.getTablePagePath(tableKey), options)
        })
    }

    handleSetTableColumnOptions = (tableKey, columns) => {
        const tableOptions = Object.assign({}, this.state[tableKey], {
            columns: columns.reduce((memo, it) => {
                memo[it.name] = it;
                return memo
            }, {})
        });

        this.setState({
            [tableKey]: tableOptions,
            columnsDialogTableKey: null
        }, () => {
            saveTableColumns(this.getTablePagePath(tableKey), tableOptions)
        })
    }

    /** Helpers
     ================================================================= */
    getTablePagePath = (tableKey) => {
        return tableKey === 'tableOptionsCurrentWO' ? this.pagePathCurrentWO : this.pagePathPastWO;
    }

    getTableOptions = (pagePath) => {
        const fields = this.getFieldsWO();
        const options = getDefaultTableOptions(fields, WO_TABLE_DEFAULTS, pagePath, this.props.translate);

        // Backfills columns added after the user's options were persisted - without it a new
        // column renders with a raw, untranslated header.
        return verifyTableOptions(fields, options, this.props.translate) ?? options;
    }

    getDefaultTableColumnOptions = () => {
        return getDefaultTableOptionsJSON(this.getFieldsWO(), WO_TABLE_DEFAULTS, this.props.translate);
    }

    getQueryCurrentWO = () => {
        return {
            sort: this.state.sortCurrentWO,
            sortBy: this.state.sortByCurrentWO,
            offset: this.state.offsetCurrentWO,
            ...FieldsManager.getFieldKeyValues(this.state.queryFilterFieldsCurrentWO),
            searchFields: JSON.stringify({
                WorkOrderStatusID: ['WorkOrderStatusID', '<>', WORK_ORDER_COMPLETED_STATUS_ID],
                TruckID: this.props.TruckID,
                TrailerID: this.props.TrailerID
            })
        }
    }

    getQueryPastWO = () => {
        return {
            sort: this.state.sortPastWO,
            sortBy: this.state.sortByPastWO,
            offset: this.state.offsetPastWO,
            ...FieldsManager.getFieldKeyValues(this.state.queryFilterFieldsPastWO),
            searchFields: JSON.stringify({
                WorkOrderStatusID: ['WorkOrderStatusID', '=', WORK_ORDER_COMPLETED_STATUS_ID],
                TruckID: this.props.TruckID,
                TrailerID: this.props.TrailerID
            })
        }
    }

    /** Fields/Data definitions
     ================================================================= */
    getFieldsWO = () => {
        const {translate} = this.props;
        const isTruck = !!this.props.TruckID;
        const workOrderStatuses = getLookup("WorkOrderStatus");

        const fieldTemplates = {
            AutoCounter: new Field('AutoCounter', '', [''], false, 'custom', {
                render: (it) => {
                    if (!it.AutoCounter) return null;

                    return (
                        <CellButton
                            onClick={() => checkPerm(Resources.WorkOrders, UPDATE_PERM) && this.handleOpenWorkOrder(it)}
                        >
                            {it.AutoCounter}
                        </CellButton>
                    )
                }
            }),
            WorkOrderStatusID: new Field('WorkOrderStatusID', '', [''], false, 'select', {
                render: (it) => <WorkOrderStatusBadge
                    workOrderStatuses={workOrderStatuses}
                    statusID={it.WorkOrderStatusID}
                />
            }),
            Labels: new Field('Labels', '', [''], false, 'custom', {
                render: (it) => !!it.ColorTag && <ResourceTableTags data={it.ColorTag}/>,
                omitSort: true
            }),
            // The parent record's own column is dead weight - every row repeats it.
            TruckID: new Field('TruckID', '', [''], false, 'custom', {
                hideTable: isTruck,
                label: "Truck",
                render: (it) => {
                    if (!it) return null;

                    if (it.TruckID) {
                        return (
                            <CellButton
                                onClick={() => checkPerm(Resources.TrucksInfo, READ_PERM) && this.handleViewTruckClick(it.TruckID)}
                            >
                                {it.Truck}
                            </CellButton>
                        )
                    }

                    return <span>{it.Truck}</span>
                }
            }),
            TrailerID: new Field('TrailerID', '', [''], false, 'custom', {
                hideTable: !isTruck,
                label: "Trailer",
                render: (it) => {
                    if (!it) return null;

                    if (it.TrailerID) {
                        return (
                            <CellButton
                                onClick={() => checkPerm(Resources.Trailer, READ_PERM) && this.handleViewTrailerClick(it.TrailerID)}
                            >
                                {it.Trailer}
                            </CellButton>
                        )
                    }

                    return <span>{it.Trailer}</span>
                }
            }),
            RequestDate: new Field('RequestDate', '', [''], false, 'date'),
            ServiceProvider: new Field('ServiceProvider', '', [''], false, 'custom', {
                omitSort: true,
                render: (it) => <div>{it.IsInHouseRepair ? translate("text.internal_shop") : it.AssignedVendor}</div>
            }),
            InitialComplaint: new Field('InitialComplaint', '', [''], false, 'text', {
                render: (it) => <div>{longTableColumn(it.InitialComplaint)}</div>
            }),
            Notes: new Field('Notes', '', [''], false, 'text', {
                label: "Description",
                render: (it) => <div>{longTableColumn(it.Notes)}</div>
            }),
            TotalAmount: new Field('TotalAmount', '', [''], false, 'float', {
                render: (it) => (
                    <Tooltip
                        content={
                            <div className="text-right">
                                <div>{translate("field.LaborAmount")}: {genericMoneyFormatter(it.LaborAmount)}</div>
                                <div>{translate("field.PartsAmount")}: {genericMoneyFormatter(it.PartsAmount)}</div>
                                <div>{translate("field.MiscAmount")}: {genericMoneyFormatter(it.MiscAmount)}</div>
                                <div>{translate("field.SurchargeAmount")}: {genericMoneyFormatter(it.SurchargeAmount)}</div>
                            </div>
                        }
                    >
                        <div className="text-right">
                            {genericMoneyFormatter(it.TotalAmount)}
                        </div>
                    </Tooltip>
                )
            }, {icon: false}),
            CreatedDate: new Field('CreatedDate', '', [''], false, 'datetime')
        }

        return fillFieldsFromData(fieldTemplates, {})
    }

    getQueryFilterFieldsCurrentWO = () => {
        return {
            query: new Field('query', '', [''], false, 'search', {}, {}),
            limit: new Field('limit', 5, [''], false, 'select', {hideLabel: true}, {menuPlacement: "top"})
        }
    }

    getQueryFilterFieldsPastWO = () => {
        return {
            query: new Field('query', '', [''], false, 'search', {}, {}),
            limit: new Field('limit', 5, [''], false, 'select', {hideLabel: true}, {menuPlacement: "top"})
        }
    }

    /** Render
     ================================================================= */
    renderWorkOrdersTable = ({
                                 title,
                                 tableKey,
                                 data,
                                 count,
                                 isLoading,
                                 queryFilterFields,
                                 sort,
                                 sortBy,
                                 offset,
                                 onRefresh,
                                 onSortChange,
                                 onFilterInputChange,
                                 onUpdateOffset,
                                 tableCardClass,
                                 headerActions
                             }) => {
        const {translate} = this.props;

        return (
            <>
                <PageHeader
                    className="flex items-center"
                    title={title}
                    titleClass="mb-5 mt-5 text-xl"
                >
                    {headerActions}

                    <TableSettingsPopOver
                        options={this.state[tableKey]}
                        setOptions={(options) => this.handleSetTableOptions(tableKey, options)}
                        toggleColumnSettingsDialog={() => this.handleToggleColumnSettingsDialog(tableKey)}
                        translate={translate}
                    />
                </PageHeader>

                <TableCard addClass={tableCardClass}>
                    <TableFilters
                        hideLimit
                        filterFields={queryFilterFields}
                        handleInputChange={onFilterInputChange}
                        translate={translate}
                        onRefreshTable={onRefresh}
                        isLoading={isLoading}
                    />

                    <ResourceTable
                        data={data}
                        fields={this.getFieldsWO()}

                        translate={translate}
                        isLoading={isLoading}

                        options={this.state[tableKey]}
                        saveTableOptions={(options) => this.handleSetTableOptions(tableKey, options)}

                        limit={queryFilterFields.limit.value}

                        sort={sort}
                        sortBy={sortBy}
                        onSortChange={onSortChange}
                    />

                    {/*Table footer*/}
                    {!(!data.length && !isLoading) && (
                        <div
                            className="bg-inverse px-4 py-3 flex items-center justify-between border-t border-tm-gray-300 sm:px-6 h-16 rounded-b-lg"
                        >
                            <Pagination
                                count={count}
                                isLoading={isLoading}
                                handleQueryChange={
                                    (name, value) => name === "offset"
                                        ? onUpdateOffset(value)
                                        : onFilterInputChange(name, value)
                                }
                                pageOffset={offset}
                                queryFields={queryFilterFields}
                                translate={translate}
                            />
                        </div>
                    )}

                    <NoRecords
                        show={(data.length === 0) && !isLoading}
                        title={translate('text.no_records')}
                        addClass={'pt-16 pb-10'}
                    />
                </TableCard>
            </>
        )
    }

    render() {
        const {translate, secondResource, thirdResource} = this.props
        const secondData = getProp(this.props, "secondResource.data.list", []);
        const countSecond = getProp(this.props, "secondResource.data.count", 0);
        const thirdData = getProp(this.props, "thirdResource.data.list", []);
        const countThird = getProp(this.props, "thirdResource.data.count", 0);

        const columnsDialogTableKey = this.state.columnsDialogTableKey;

        return (
            <div className="space-y-8 pb-8">
                <Card>
                    <PageHeader
                        title={translate('page.heading.OutOfService')}
                        titleClass="mb-5 mt-5 text-xl"
                    />

                    <ResourceListTab
                        tabKey={this.props.tabKey}
                        id={this.props.TruckID ?? this.props.TrailerID}
                        dispatch={this.props.dispatch}
                        translate={this.props.translate}
                        resource={this.props.resource}
                        disableEdit={this.props.disableEdit}
                        disableDelete={this.props.disableDelete}

                        dialogTitle={translate('title.out_of_service_entry')}
                        hideTitle={true}
                        infoParagraph={translate('text.OutOfServiceInfo', [translate(this.props.TruckID ? 'text.truck' : 'text.trailer').toLowerCase()])}

                        sortBy={this.props.sortBy}
                        primaryKey={this.props.primaryKey}
                        resourceName={this.props.resourceName}
                        fields={() => {return {
                            WorkOrder: new Field("WorkOrder", '', [], false, 'text', {
                                addContainerClass: "col-span-full",
                                hideDialog: true
                            }),
                            OutOfServiceDate: new Field("OutOfServiceDate", '', ['empty'], false, 'date', {addContainerClass: "col-span-full"}),
                            ReturnsToServiceDate: new Field("ReturnsToServiceDate", '', [], false, 'date', {addContainerClass: "col-span-full"}),
                            ServiceNotes: new Field("ServiceNotes", '', ['empty'], false, 'textarea', {addContainerClass: "col-span-full"}),
                        }}}
                        searchFields={{
                            query: new Field('query', '', [''], false, 'search', {}),
                            limit: new Field('limit', DEFAULT_QUERY_LIMIT, [''], false, 'select', {
                                hideLabel: true
                            })
                        }}
                        actions={[{
                            title: () => translate("btn.view_work_order"),
                            action: (it) => checkPerm(Resources.WorkOrders, UPDATE_PERM) && openInNewTab(Env.getTruckWorkOrdersUrl("/work-orders/" + it?.WorkOrderID)),
                            icon: () => EyeIcon,
                            visible: (it) => !!it.WorkOrderID
                        }]}
                    />
                </Card>

                {checkPerm(Resources.WorkOrders, READ_PERM) && (<div>
                        <Card addClass={"mt-5"}>
                            {this.renderWorkOrdersTable({
                                title: translate('page.heading.CurrentWO'),
                                tableKey: 'tableOptionsCurrentWO',
                                data: secondData,
                                count: countSecond,
                                isLoading: secondResource.isLoading,
                                queryFilterFields: this.state.queryFilterFieldsCurrentWO,
                                sort: this.state.sortCurrentWO,
                                sortBy: this.state.sortByCurrentWO,
                                offset: this.state.offsetCurrentWO,
                                onRefresh: this.fetchDataCurrentWO,
                                onSortChange: this.handleUpdateSortCurrentWO,
                                onFilterInputChange: this.handleFilterInputChangeCurrentWO,
                                onUpdateOffset: this.handleUpdateOffsetCurrentWO,
                                tableCardClass: "relative",
                                // The record spans the whole date range, not just this table -
                                // it sits here because this is the first work order section.
                                headerActions: (
                                    <Button
                                        appearance="muted"
                                        onClick={this.handleToggleMvrExportDialog}
                                    >
                                        {translate('btn.download_mvr_record')}
                                    </Button>
                                )
                            })}
                        </Card>

                        <Card addClass="relative mt-5">
                            {this.renderWorkOrdersTable({
                                title: translate('page.heading.PastWO'),
                                tableKey: 'tableOptionsPastWO',
                                data: thirdData.filter((it) => it.WorkOrderStatusID === WORK_ORDER_COMPLETED_STATUS_ID),
                                count: countThird,
                                isLoading: thirdResource.isLoading,
                                queryFilterFields: this.state.queryFilterFieldsPastWO,
                                sort: this.state.sortPastWO,
                                sortBy: this.state.sortByPastWO,
                                offset: this.state.offsetPastWO,
                                onRefresh: this.fetchDataPastWO,
                                onSortChange: this.handleUpdateSortPastWO,
                                onFilterInputChange: this.handleFilterInputChangePastWO,
                                onUpdateOffset: this.handleUpdateOffsetPastWO,
                                tableCardClass: "relative z-10"
                            })}
                        </Card>
                    </div>
                )}

                <TableOptionsDialog
                    show={!!columnsDialogTableKey}
                    modalTitle={
                        translate(columnsDialogTableKey === 'tableOptionsPastWO' ? 'page.heading.PastWO' : 'page.heading.CurrentWO')
                        + translate("modal_heading.table_column_settings")
                    }
                    columns={this.state[columnsDialogTableKey ?? 'tableOptionsCurrentWO'].columns}
                    setTableColumnOptions={(columns) => this.handleSetTableColumnOptions(columnsDialogTableKey, columns)}
                    getDefaultTableColumnOptions={this.getDefaultTableColumnOptions}
                    onClose={() => this.handleToggleColumnSettingsDialog(null)}
                    translate={translate}
                />

                <ModalMvrRecordExport
                    show={this.state.isMvrExportDialogOpen}
                    onClose={this.handleToggleMvrExportDialog}
                    dispatch={this.props.dispatch}
                    translate={translate}
                    TruckID={this.props.TruckID}
                    TrailerID={this.props.TrailerID}
                    unitNumber={this.props.unitNumber}
                />
            </div>
        )
    }
}
